<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <!--<img src="@/assets/img/back.png" alt="">-->
        <span style="color: #FFFFFF">找人才</span>
      </p>
    </header>
    <div style="margin-top: 65px;padding-bottom: 70px">
      <!--<div style="background-color:#6e9bcf" v-for="(index,key) in list">-->
      <div class="leaderDiv" v-for="(index,key) in list" @click="toTalentsDtails(index.userid)">
        <!--<h3>职位Leader</h3>-->
        <div class="Leader">
          <div class="LeaderMessage">
            <p class="personalTopNmae">{{index.name}}</p>
            <p  class="LeaderSpan" style="color: #c1c0c0">
              <span >{{index.residence}}</span>
              <span >{{index.workage}}年</span>
              <span  v-if="index.education==1">初中</span>
              <span  v-else-if="index.education==2">高中</span>
              <span  v-else-if="index.education==3">中专</span>
              <span  v-else-if="index.education==4">大专</span>
              <span  v-else-if="index.education==5">本科</span>
              <span  v-else-if="index.education==6">硕士</span>
              <span  v-else-if="index.education==7">博士</span>
              <span  >15K-20K</span>
              <span  v-if="index.expectsalary==1">1K-2K</span>
              <span  v-else-if="index.expectsalary==2">2K-4K</span>
              <span v-else-if="index.expectsalary==3">4K-6K</span>
              <span v-else-if="index.expectsalary==4">6K-8K</span>
              <span v-else-if="index.expectsalary==5">8K-10K</span>
              <span v-else-if="index.expectsalary==6">10K-15K</span>
              <span v-else-if="index.expectsalary==7">20K-25K</span>
              <span v-else-if="index.expectsalary==8">20K-25K</span>
              <span v-else-if="index.expectsalary==9">25K-35K</span>
              <span v-else-if="index.expectsalary==10">35K-50KK</span>
              <span v-else-if="index.expectsalary==11">50K-70K</span>
              <span v-else-if="index.expectsalary==12">70K-100K</span>
              <span v-else-if="index.expectsalary==13">100K以上</span>
            </p>

          </div>
          <div class="comPosition" >
            <img v-if="index.photo"  :src=index.photo alt="">
            <img v-else=""   src="@/assets/img/tx.jpg" alt="">
          </div>

        </div>
        <div class="LeaderL">
          <p class="leaderFont" style="color: #505050eb" v-if="index.workexperience[0]">
            <span class="leaderFontSpan">{{index.workexperience[0].name}}</span>
            <span> &nbsp;&nbsp;·{{ index.workexperience[0].positionname}}</span>
          </p>
          <p class="leaderFont" style="color: #505050eb" v-if="index.school?index.school[0]:{}">{{index.school[0].name}}·{{index.school[0].major}}</p>
          <!--<span class="leaderFontY" style="color: #505050eb">移动互联网</span>-->
          <p class="introduction" style="color: #505050eb">{{index.introduction}}</p>
          <span class="laader" style="font-size: 12px"></span>
        </div>
      </div>
    </div>
    <van-tabbar route v-model="active">
      <van-tabbar-item replace to="/comTalents" icon="wap-home-o">
        招人才
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMessage" icon="envelop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/comPosition" icon="desktop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace to="/comMy" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 'a',
        active:0,
        list:{}
      }
    },
    mounted(){
      this.obtainMyer()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toTalentsDtails(id){
        console.log(id)
        this.$router.push({
        path:"/comTalentsDtails",
          query:{
          id:id
          }
        })
      },
      obtainMyer(){
        this.$api.obtainMy()
          .then(res=>{
           this.list=res.data
            console.log(this.list)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
*{
  padding: 0;
  margin: 0;
}
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
.Leader{
  padding: 10px 1rem 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  /*border-bottom: solid 7px #EAEAEA;*/
  background: #FFFFFF;
  border-radius: 20px 20px 0 0 ;
}
.LeaderMessage p{
  padding-top: 6px;
  /*font-size: 12px;*/
}
.leaderFont{
   font-size: 14px;
  display: flex;
  /*max-width: 19px;*/
}
  .comPosition img{
    width: 60px;
    height: 60px;
    border-radius: 100%;
  }
  .personalTopNmae{
    font-weight: 800;
  }
  .leaderFont span{
    display: inline-block;
  }
  .leaderFontSpan{
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    /*max-width: 41vw;*/
    /*margin-bottom: -3px;*/
  }
  /*.leaderFont{*/
    /*font-size: 14px;*/
  /*}*/
.leaderFontY{
  background: #7fb3db;
  padding: 4px;
  border-radius: 6px;
  font-size: 12px;
  margin: 7px 0;
  display: inline-block;
}
.leaderDiv:first-child{
  background: #6e9bcf;
}
.LeaderSpan span{
  font-size: 14px;
}
.introduction{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 10rem;
  font-size: 14px;
}
.LeaderL{
  padding: 0PX 1rem;
  background: #FFFFFF;
  border-bottom: solid 7px #EAEAEA;
}
  /*.LeaderMessage */
</style>



// WEBPACK FOOTER //
// src/components/company/comTalents.vue